// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.job-status-card {
  margin-top: 10px;
  padding: 12px 14px;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  background: #f8fafc;
  font-size: 13px;
  line-height: 1.4;
  color: #0f172a;
}

.job-status-card--in_progress {
  border-color: #38bdf8;
  background: #f0f9ff;
}

.job-status-card--completed {
  border-color: #22c55e;
  background: #f0fdf4;
}

.job-status-card--failed {
  border-color: #ef4444;
  background: #fef2f2;
}

.job-status-card__header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
}

.job-status-card__icon {
  font-size: 14px;
}

.job-status-card__label {
  letter-spacing: 0.02em;
}

.job-status-card__id {
  font-family: ui-monospace, 'SFMono-Regular', Menlo, Consolas, monospace;
  color: #475569;
  font-weight: 500;
}

.job-status-card__elapsed {
  margin-left: auto;
  color: #64748b;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
}

.job-status-card__body {
  margin-top: 6px;
}

.job-status-card__op {
  color: #475569;
  font-size: 12px;
  margin-bottom: 4px;
}

.job-status-card__progress {
  color: #0369a1;
}

.job-status-card__result {
  color: #166534;
}

.job-status-card__error {
  color: #b91c1c;
  white-space: pre-wrap;
}

.job-status-card__warning {
  margin-top: 6px;
  color: #92400e;
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/JobStatusCard/JobStatusCard.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uEAAuE;EACvE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB","sourcesContent":[".job-status-card {\n  margin-top: 10px;\n  padding: 12px 14px;\n  border-radius: 8px;\n  border: 1px solid #cbd5e1;\n  background: #f8fafc;\n  font-size: 13px;\n  line-height: 1.4;\n  color: #0f172a;\n}\n\n.job-status-card--in_progress {\n  border-color: #38bdf8;\n  background: #f0f9ff;\n}\n\n.job-status-card--completed {\n  border-color: #22c55e;\n  background: #f0fdf4;\n}\n\n.job-status-card--failed {\n  border-color: #ef4444;\n  background: #fef2f2;\n}\n\n.job-status-card__header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 600;\n}\n\n.job-status-card__icon {\n  font-size: 14px;\n}\n\n.job-status-card__label {\n  letter-spacing: 0.02em;\n}\n\n.job-status-card__id {\n  font-family: ui-monospace, 'SFMono-Regular', Menlo, Consolas, monospace;\n  color: #475569;\n  font-weight: 500;\n}\n\n.job-status-card__elapsed {\n  margin-left: auto;\n  color: #64748b;\n  font-weight: 500;\n  font-variant-numeric: tabular-nums;\n}\n\n.job-status-card__body {\n  margin-top: 6px;\n}\n\n.job-status-card__op {\n  color: #475569;\n  font-size: 12px;\n  margin-bottom: 4px;\n}\n\n.job-status-card__progress {\n  color: #0369a1;\n}\n\n.job-status-card__result {\n  color: #166534;\n}\n\n.job-status-card__error {\n  color: #b91c1c;\n  white-space: pre-wrap;\n}\n\n.job-status-card__warning {\n  margin-top: 6px;\n  color: #92400e;\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
